import { PropsWithChildren } from 'react';

/**
 * Props of Tooltip component
 *
 * @author Vitalii Bodnarchuk
 */
interface TooltipProps extends PropsWithChildren {
  /**
   * content of tooltip
   */
  readonly text?: string;

  /**
   * content of tooltip
   */
  readonly content?: JSX.Element;

  /**
   * behavior of tooltip
   */
  readonly behavior?: 'click' | 'focus' | 'hover';
}

enum TooltipBehavior {
  CLICK = 'click',
  FOCUS = 'focus',
  HOVER = 'hover',
}

export { TooltipBehavior };
export type { TooltipProps };
